
































import { defineComponent, ref } from "@vue/composition-api";

/**
 * 头部导航
 */
export default defineComponent({
  props: {
    title: {
      type: String,
      default: "病虫害百科",
    },
    content: {
      type: String,
      default: "",
    },
    showBack: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["back", "search", "clear"],
  setup(props) {
    const keyword = ref("");
    keyword.value = props.content ? props.content : "";

    const isShowSearch = props.title != "" ? ref(false) : ref(true);

    const handleSearch = () => {
      isShowSearch.value = true;
    };

    return {
      keyword,
      isShowSearch,
      handleSearch,
    };
  },
});
